<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 财务管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>工资单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-date-picker
					type="month"
					placeholder="请选择月份"
					v-model="query.totalMonth"
					value-format="yyyy-MM"
				></el-date-picker>&nbsp;
				<el-input v-model="query.name" placeholder="姓名" class="handle-input mr10" style="width:200px"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>&nbsp;&nbsp;
				<a href="https://img.zelixin.cn/template/工资单导入模板.xlsx" style="font-size:12px;color:#66b1ff">工资单模板</a>&nbsp;&nbsp;
				<a href="https://img.zelixin.cn/template/年终奖导入模板.xlsx" style="font-size:12px;color:#66b1ff">年终奖模板</a>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center" :selectable="isSelectable"></el-table-column>
				<el-table-column prop="recordType" label="类型" width="80">
					<template slot-scope="scope">
						{{scope.row.recordType==1?"年终奖":(scope.row.bankNo=="合计："?"":"工资")}}
					</template>
				</el-table-column>
                <el-table-column prop="totalMonth" label="月份" width="100"></el-table-column>
				<el-table-column prop="name" label="姓名" width="120"></el-table-column>
				<el-table-column prop="bankNo" label="银行卡号"></el-table-column>
				<el-table-column prop="salaryPayable" label="应发放金额" width="100"></el-table-column>
				<el-table-column prop="status" label="状态" :formatter="statusFormat" width="80"></el-table-column>
				<el-table-column prop="grantTime" label="发放日期" width="120"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
                <el-table-column label="操作" width="180px" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit'] && scope.row.status == 0"
                        >编辑</el-button>
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleView(scope.$index, scope.row)"
							v-if="controll['show'] && scope.row.status > 0"
                        >详情</el-button>
						<el-button
                            type="text"
                            icon="el-icon-check"
                            @click="handleView(scope.$index, scope.row)"
							v-if="controll['show'] && scope.row.status==0"
                        >复核</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
							class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete'] && scope.row.status == 0"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
					style="float:left"
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-dropdown 
					style="float:left;margin-right:10px;"
					icon="el-icon-lx-add"
					split-button 
					type="primary" 
					v-if="controll['add']" 
					@click="handleAdd"
					@command="handleCommand">
					<i class="el-icon-lx-add"></i> 添加记录
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="swage">添加工资记录</el-dropdown-item>
						<el-dropdown-item command="bonus">添加年终奖记录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-upload
					style="float:left"
					class="upload-demo mr10"
					accept=".xls,.xlsx"
					action= "/blob/salary/import-excel"
					:on-success="wagesUploadSuccess"
					:file-list="fileList"
					:show-file-list = "false"
					v-if="controll['import']"
					list-type="picture">
					<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import']">导入工资单</el-button>
				</el-upload>
				<el-upload
					style="float:left"
					class="upload-demo mr10"
					accept=".xls,.xlsx"
					action= "/blob/salary/import-excel-bonus"
					:on-success="bonusUploadSuccess"
					:file-list="fileList"
					:show-file-list = "false"
					v-if="controll['import']"
					list-type="picture">
					<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import']">导入年终奖</el-button>
				</el-upload>
				<el-button
					style="float:left"
                    type="primary"
                    icon="el-icon-s-ticket"
                    class="handle-del mr10"
                    @click="handleGrantSalary"
					v-if="controll['grant']"
                >发放标记</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="添加工资记录" :visible.sync="editVisible" width="70%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-row>
					<el-col :span="8">
						<el-form-item label="月份" prop="totalMonth">
							<el-date-picker 
								type="month"
								placeholder="工资所属月份"
								v-model="form.totalMonth"
								value-format="yyyy-MM"
								style="width:180px;"
							></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="姓名" prop="name">
							<el-input v-model="form.name" placeholder="姓名"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="银行卡号" prop="bankNo">
							<el-input v-model="form.bankNo" placeholder="银行卡号"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="应出勤天数" prop="attendanceRequired">
							<el-input v-model="form.attendanceRequired" placeholder="应出勤天数"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="实际出勤天数" prop="actualAttendance">
							<el-input v-model="form.actualAttendance" placeholder="实际出勤天数"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="全勤奖" prop="fullAttendance">
							<el-input v-model="form.fullAttendance" placeholder="全勤奖"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="基本工资" prop="baseSalary">
							<el-input v-model="form.baseSalary" placeholder="基本工资"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="绩效工资" prop="performance">
							<el-input v-model="form.performance" placeholder="绩效工资"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="业务提成/项目奖" prop="bonus">
							<el-input v-model="form.bonus" placeholder="业务提成/项目奖"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="其他收入" prop="otherIncome">
							<el-input v-model="form.otherIncome" placeholder="其他收入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="其他收入说明" prop="otherIncomeRemark">
							<el-input v-model="form.otherIncomeRemark" placeholder="其他收入说明"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="请假时长" prop="leaveDuration">
							<el-input v-model="form.leaveDuration" placeholder="请假时长"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="请假扣除" prop="leaveDeduction">
							<el-input v-model="form.leaveDeduction" placeholder="请假扣除"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="养老保险" prop="retirementInsurance">
							<el-input v-model="form.retirementInsurance" placeholder="养老保险"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="医疗保险" prop="medicalTreatmentInsurance">
							<el-input v-model="form.medicalTreatmentInsurance" placeholder="医疗保险"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="失业保险" prop="unemploymentInsurance">
							<el-input v-model="form.unemploymentInsurance" placeholder="失业保险"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="工伤保险" prop="industrialInjuryInsurance">
							<el-input v-model="form.industrialInjuryInsurance" placeholder="工伤保险"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="生育保险" prop="birthInsurance">
							<el-input v-model="form.birthInsurance" placeholder="生育保险"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="住房公积金" prop="accumulationFund">
							<el-input v-model="form.accumulationFund" placeholder="住房公积金"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="其他扣除" prop="otherDeduction">
							<el-input v-model="form.otherDeduction" placeholder="其他扣除"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="其他扣除说明" prop="deductionRemark">
							<el-input v-model="form.deductionRemark" placeholder="其他扣除说明"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="个税扣除" prop="personalIncomeTax">
						<el-input v-model="form.personalIncomeTax" placeholder="个税扣除"></el-input>
					</el-form-item>
				</el-col>
					<el-col :span="12">
						<el-form-item label="应发放工资" prop="salaryPayable">
							<el-input v-model="form.salaryPayable" placeholder="应发放工资"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="添加年终奖记录" :visible.sync="bonusEditVisible" width="50%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="月份" prop="totalMonth">
							<el-date-picker 
								type="month"
								placeholder="发放月份"
								v-model="form.totalMonth"
								value-format="yyyy-MM"
								style="width:180px;"
							></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="姓名" prop="name">
							<el-input v-model="form.name" placeholder="姓名"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="银行卡号" prop="bankNo">
					<el-input v-model="form.bankNo" placeholder="银行卡号"></el-input>
				</el-form-item>
				<el-row>
					<el-col :span="12">
						<el-form-item label="个税扣除" prop="personalIncomeTax">
						<el-input v-model="form.personalIncomeTax" placeholder="个税扣除"></el-input>
					</el-form-item>
				</el-col>
					<el-col :span="12">
						<el-form-item label="应发放金额" prop="salaryPayable">
							<el-input v-model="form.salaryPayable" placeholder="应发放金额"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="备注" prop="remark">
					<el-input type=textarea :rows=3 v-model="form.remark"> </el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="bonusEditVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveBonusEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<!-- 详情 -->
		<el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="viewVisible" width="50%">
            <el-form ref="view" :model="view" label-width="100px">
				<el-descriptions class="margin-top" title="" :column="2" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label"> 月份 </template>
						{{view.totalMonth}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label"> 类型 </template>
						{{view.recordType==1?"年终奖":"工资"}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label"> 姓名 </template>
						{{view.name}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label"> 银行卡号 </template>
						{{view.bankNo}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 应出勤天数 </template>
						{{view.attendanceRequired}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 实际出勤天数 </template>
						{{view.actualAttendance}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 全勤奖 </template>
						{{view.fullAttendance}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 基本工资 </template>
						{{view.baseSalary}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 绩效工资 </template>
						{{view.performance}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 业务提成/项目奖 </template>
						{{view.bonus}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 其他收入 </template>
						{{view.otherIncome}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 其他收入说明 </template>
						{{view.otherIncomeRemark}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 养老保险 </template>
						{{view.retirementInsurance}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 失业保险 </template>
						{{view.unemploymentInsurance}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 工伤保险 </template>
						{{view.industrialInjuryInsurance}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 生育保险 </template>
						{{view.birthInsurance}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 住房公积金 </template>
						{{view.accumulationFund}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 请假时长 </template>
						{{view.leaveDuration}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 请假扣除 </template>
						{{view.leaveDeduction}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 其他扣除 </template>
						{{view.otherDeduction}}
					</el-descriptions-item>
					<el-descriptions-item v-if="view.recordType==0">
						<template slot="label"> 其他扣除说明 </template>
						{{view.deductionRemark}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label"> 个税扣除 </template>
						{{view.personalIncomeTax}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label" v-if="view.recordType==0"> 应发放工资 </template>
						<template slot="label" v-if="view.recordType==1"> 应发放奖金 </template>
						{{view.salaryPayable}}
					</el-descriptions-item>	
					<el-descriptions-item>
						<template slot="label"> 状态 </template>
						{{statusFormat(null, null, view.status)}}
					</el-descriptions-item>		
					<el-descriptions-item>
						<template slot="label"> 发放日期 </template>
						{{view.grantTime}}
					</el-descriptions-item>		
					<el-descriptions-item>
						<template slot="label"> 备注 </template>
						{{view.remark}}
					</el-descriptions-item>		
				</el-descriptions>
            </el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="viewVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleCheckSalary" v-prevent-re-click>复 核</el-button>
            </span>
        </el-dialog>
		
		<!-- 报销弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="发放标记" :visible.sync="grantVisible" width="35%">
            <el-form ref="grantForm" :model="grantForm" label-width="100px" :rules="grantSalaryRules">
				<el-form-item label="发放日期" prop="grantTime">
					<el-date-picker
						type="date"
						placeholder="请选择发放日期"
						v-model="grantForm.grantTime"
						value-format="yyyy-MM-dd"
					></el-date-picker>
                </el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input type=textarea :rows=3 v-model="grantForm.remark"> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="grantVisible = false">取 消</el-button>
                <el-button type="primary" @click="grantSalary" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="预览" :visible.sync="previewVisible" fullscreen>
            <el-table
                :data="previewData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
				height="600px"
            >
				<el-table-column prop="totalMonth" label="月份"></el-table-column>
				<el-table-column prop="name" label="姓名"></el-table-column>
				<el-table-column prop="bankNo" label="银行卡号"></el-table-column>
				<el-table-column prop="attendanceRequired" label="应出勤天数" v-if="previewType==0"></el-table-column>
				<el-table-column prop="actualAttendance" label="实际出勤天数" v-if="previewType==0"></el-table-column>
				<el-table-column prop="baseSalary" label="基本工资" v-if="previewType==0"></el-table-column>
				<el-table-column prop="performance" label="绩效工资" v-if="previewType==0"></el-table-column>
				<el-table-column prop="fullAttendance" label="全勤奖" v-if="previewType==0"></el-table-column>
				<el-table-column prop="bonus" label="业务提成/项目奖" v-if="previewType==0"></el-table-column>
				<el-table-column prop="otherIncome" label="其他收入" v-if="previewType==0"></el-table-column>
				<el-table-column prop="otherIncomeRemark" label="其他收入说明" v-if="previewType==0"></el-table-column>
				<el-table-column prop="retirementInsurance" label="养老保险" v-if="previewType==0"></el-table-column>
				<el-table-column prop="medicalTreatmentInsurance" label="医疗保险" v-if="previewType==0"></el-table-column>
				<el-table-column prop="unemploymentInsurance" label="失业保险" v-if="previewType==0"></el-table-column>
				<el-table-column prop="industrialInjuryInsurance" label="工伤保险" v-if="previewType==0"></el-table-column>
				<el-table-column prop="birthInsurance" label="生育保险" v-if="previewType==0"></el-table-column>
				<el-table-column prop="accumulationFund" label="住房公积金" v-if="previewType==0"></el-table-column>
				<el-table-column prop="leaveDuration" label="请假时长" v-if="previewType==0"></el-table-column>
				<el-table-column prop="leaveDeduction" label="请假扣除" v-if="previewType==0"></el-table-column>
				<el-table-column prop="personalIncomeTax" label="个税扣除"></el-table-column>
				<el-table-column prop="otherDeduction" label="其他扣除" v-if="previewType==0"></el-table-column>
				<el-table-column prop="deductionRemark" label="其他扣除说明" v-if="previewType==0"></el-table-column>
				<el-table-column prop="salaryPayable" label="应发放工资" v-if="previewType==0"></el-table-column>
				<el-table-column prop="salaryPayable" label="应发放金额" v-if="previewType==1"></el-table-column>
				<el-table-column prop="remark" label="备注" v-if="previewType==1"></el-table-column>
            </el-table>
			<span slot="footer" class="dialog-footer">
                <el-button @click="previewVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveBatch" v-prevent-re-click>保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchSalaryData, saveSalary, deleteSalary, getSalary, grantSalary, checkSalary, saveBatchSalary, saveBonus } from '../../../api/index';
export default {
    name: 'salary',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
			show:{},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			rules: {
				totalMonth: [{ required: true, message: '请选择发放日期', trigger: 'blur' }],
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				attendanceRequired: [{ required: true, message: '请输入应出勤天数', trigger: 'blur' }],
				actualAttendance: [{ required: true, message: '请输入实际出勤天数', trigger: 'blur' }],
				baseSalary: [{ required: true, message: '请输入基本工资', trigger: 'blur' }],
				salaryPayable: [{ required: true, message: '请输入应发放工资', trigger: 'blur' }]
            },
			grantSalaryRules: {
                grantTime: [{ required: true, message: '请选择发放日期', trigger: 'blur' }]
			},
			statusKV:[{"key":0,"value":"已核算"},{"key":1,"value":"已复核"},{"key":2,"value":"已发放"}],
			controll:{},
			grantVisible:false,
			grantForm:{},
			viewVisible:false,
			view:[],
			previewData:[],
			uuid:"",
			previewVisible:false,
			fileList:[],
			checkOutVisible:false,
			bonusEditVisible:false,
			previewType:-1
        };
    },
    created() {
		this.controll = getControll("salary");
        this.getData();
    },
    methods: {
		saveBatch() {
			saveBatchSalary(this.uuid).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.previewVisible = false;
					this.getData();
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			})
		},
		isSelectable(row, index) {
			return row.status == 1;
		},
		//打开报销窗口
		handleGrantSalary() {
			let ids = this.getIds();
			if (ids.length == 0) {
				return;
			}
			this.grantVisible = true;
			this.$set(this.grantForm, "ids", ids);
		},
		//报销
		grantSalary() {
			this.$refs.grantForm.validate(valid => {
				if (valid) {
					grantSalary(this.grantForm).then(res => {
						if (res.code == 0) {
							this.$message.success('更新成功！');
							this.grantVisible = false;
							this.getData();
						} else {
							this.$message.error(`更新失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		handleView(index, row) {
			getSalary(row.id).then(res => {
				if (res.code == 0) {
					this.view = res.data;
					this.title = "详情";
					this.viewVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		statusFormat(row, column, cellValue) {
			let statusConfig = {0:"已核算",1:"已复核", 2:"已发放"};
			return statusConfig[cellValue];
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchSalaryData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
					let salaryPayable = 0;
					let summary = {};
					summary["bankNo"] = "合计：";
					for (var i = 0; i < res.data.records.length; i++) {
						salaryPayable += res.data.records[i]["salaryPayable"];
					}
					summary["salaryPayable"] = salaryPayable;
					if (res.data.tatistics) {
						summary["grantTime"] = "总计：";
						summary["createTime"] = res.data.tatistics["salaryPayable"];
					}
					this.tableData.push(summary);
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteSalary([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            let ids = this.getIds();
			if (ids.length == 0) {
				return;
			}
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteSalary(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//复核
		handleCheckSalary() {
			this.$confirm('确定工资信息无误吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					checkSalary(this.view.id).then(res => {
						if (res.code == 0) {
							this.$message.success('复核成功');
							this.viewVisible = false;
							this.getData();
						} else {
							this.$message.error(`复核失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.uuid = "";
			this.title = "添加工资记录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			getSalary(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					if (this.form.recordType == 0) {
						this.editVisible = true;
					} else if (this.form.recordType == 1){
						this.bonusEditVisible = true;
					}
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		//详情操作
		handleShow(index, row) {
			this.idx = index;
			this.show = row;
			this.showVisible = true;
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveSalary(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
							if (this.previewVisible) {
								let index = this.previewData.findIndex(item => {
									if(item['no'] == this.form['SalaryNo'] || item['invoiceCode'] + '-' + item['invoiceNo'] == this.form['SalaryNo']) {
										return true;
									}
								})
								if (index > -1) {
									this.previewData.splice(index, 1);
								}
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		saveBonusEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveBonus(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.bonusEditVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		//获取id
		getIds() {
			let ids = [];
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要操作的记录！`);
				return;
			}
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			return ids;
		},
		//上传成功
		uploadSuccess(response, file, fileList, previewType) {
			if (response.code == 0 ) {
				this.previewData = response.data.obj;
				this.uuid = response.data.uuid;
				this.previewType = previewType;
				this.previewVisible = true;
			} else {
				this.$message.error(response.message);
			}
		},
		wagesUploadSuccess(response, file, fileList) {
			this.uploadSuccess(response, file, fileList, 0);
		},
		bonusUploadSuccess(response, file, fileList) {
			this.uploadSuccess(response, file, fileList, 1);
		},
		//下拉列表点击
		handleCommand(command){
			if (command == "swage") {
				this.form = {};
				this.title = "添加工资记录";
				this.editVisible = true;
			} else if (command == "bonus") {
				this.form = {};
				this.title = "添加年终奖记录";
				this.bonusEditVisible = true;
			}
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
